module.exports = __webpack_public_path__ + "static/img/Four of Wands.9abea33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Four of Wands.jpg
// module id = 1273
// module chunks = 0